import React from 'react';
import { YIELD_DEFAULT_ROUND } from 'screens/YieldV2/constants';
import FormInputWithPrecisionDisplay from '../../../FormInputWithPrecisionDisplay';

const ForeignMaterialField = () => {
  return (
    <div className="flex flex-col gap-0.5 weight-input">
      <label
        htmlFor="foreign-material"
        className="text-neutral-60 tracking-tighter text-sm"
      >
        Foreign Material
      </label>
      <FormInputWithPrecisionDisplay
        fieldName="foreignMaterial"
        inputSuffix="%"
        id="foreign-material"
        round={YIELD_DEFAULT_ROUND}
      />
    </div>
  );
};

export default ForeignMaterialField;
